import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41efe2da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fas fa-plus me-2" }),
    /*#__PURE__*/_createTextVNode("เพิ่มโครงการ")
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "card-subtitle text-muted" }, "เพิ่มข้อมูลโครงการและจัดสรรงบประมาณ เพื่อให้เจ้าหน้าที่ประจำจังหวัดสามารถรายงานผลการดำเนินงาน")
], -1))
const _hoisted_3 = { class: "card-body my-3" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "input-group mb-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-coins" })
], -1))
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "col-sm-6" }
const _hoisted_10 = { class: "input-group mb-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-sign" })
], -1))
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "table table-hover mb-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "จังหวัด"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "งบกลางที่ได้รับรวม")
  ])
], -1))
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-dot-circle me-2" }, null, -1))
const _hoisted_17 = { class: "text-end" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "row",
  colspan: "2"
}, "รวมงบกลางที่ได้รับทั้งหมด:", -1))
const _hoisted_19 = { class: "text-end" }
const _hoisted_20 = {
  key: 1,
  class: "card card-empty my-2"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-body d-flex justify-content-center align-items-center text-danger" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-exclamation-triangle me-2" }),
  /*#__PURE__*/_createTextVNode("ไม่พบข้อมูลของจังหวัดภายใต้เขตตรวจราชการนี้ ")
], -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "alert-message" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "alert-heading" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "far fa-fw fa-bell me-2" }),
    /*#__PURE__*/_createTextVNode("เกิดข้อผิดพลาด!")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "กรุณาติดต่อผู้ดูแลระบบเพื่อกำหนดหน้าที่รับผิดชอบก่อน")
], -1))
const _hoisted_25 = [
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.assigned)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _withDirectives(_createElementVNode("select", {
                          class: "form-select",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedFiscalYear) = $event)),
                          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filterChange && _ctx.filterChange(...args)))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fiscalYears, (fiscalYear) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: fiscalYear.id,
                              value: fiscalYear
                            }, _toDisplayString(fiscalYear.name), 9, _hoisted_8))
                          }), 128))
                        ], 544), [
                          [_vModelSelect, _ctx.selectedFiscalYear]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        _withDirectives(_createElementVNode("select", {
                          class: "form-select",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedRegion) = $event)),
                          onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.filterChange && _ctx.filterChange(...args)))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regions, (region) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: region.id,
                              value: region
                            }, _toDisplayString(region.name), 9, _hoisted_12))
                          }), 128))
                        ], 544), [
                          [_vModelSelect, _ctx.selectedRegion]
                        ])
                      ])
                    ])
                  ]),
                  (_ctx.isProvinceLoading)
                    ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_ctx.provinces)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("table", _hoisted_13, [
                                _hoisted_14,
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.provinces, (province, index) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      class: _normalizeClass(["row-hover", {'table-active': province.id === _ctx.selectedProvince?.id}]),
                                      key: province.id,
                                      onClick: ($event: any) => (_ctx.provinceChange(province))
                                    }, [
                                      _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                                      _createElementVNode("td", null, [
                                        _hoisted_16,
                                        _createTextVNode(_toDisplayString(!province.name.startsWith('กรุงเทพมหานคร') ? `จังหวัด${province.name}` : province.name), 1)
                                      ]),
                                      _createElementVNode("td", _hoisted_17, _toDisplayString(Number(province.totalBudget).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + " บาท", 1)
                                    ], 10, _hoisted_15))
                                  }), 128))
                                ]),
                                _createElementVNode("tfoot", null, [
                                  _createElementVNode("tr", null, [
                                    _hoisted_18,
                                    _createElementVNode("td", _hoisted_19, _toDisplayString(Number(_ctx.provinces?.filter(m => m.id === 1).reduce((total, m) => total + m.totalBudget, 0)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + " บาท", 1)
                                  ])
                                ])
                              ]),
                              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.projectComponent), {
                                "fiscal-year": _ctx.selectedFiscalYear,
                                province: _ctx.selectedProvince,
                                onToggle: _ctx.toggle
                              }, null, 40, ["fiscal-year", "province", "onToggle"]))
                            ], 64))
                          : (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
                      ], 64))
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
          ], 64))
    ])
  ]))
}